/* eslint-disable */

import Component from 'gia/Component'
import select2 from 'select2'

export default class SelectTwo extends Component {
  constructor(element) {
    super(element)
  }

  select() {
    const dropdown = $(this.element)
    $(dropdown).select2()
  }

  mount() {
    this.select()
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/SelectTwo.js